import { QueryClient } from '@tanstack/react-query';

import { toAppError } from '../errors/app-error.js';

/**
 * Política de caché por defecto.
 *
 * `staleTime` de un minuto evita que cada montaje y cada vuelta de foco
 * dispare la misma consulta — el problema que costó segundos en el móvil.
 * No se reintenta ante 401/403: reintentar un permiso denegado solo gasta
 * viajes y retrasa el mensaje al usuario.
 */
export function createAppQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          const kind = toAppError(error).kind;
          if (kind === 'autenticacion' || kind === 'permiso' || kind === 'validacion') {
            return false;
          }
          return failureCount < 2;
        },
      },
      mutations: { retry: false },
    },
  });
}
